import { useAuthStore } from '@/stores/authStore'

/**
 * Read-only auth state hook — thin Zustand selectors with no side effects.
 *
 * Use this instead of `useAuth()` when you only need to read auth state.
 * Components using this hook do NOT trigger Kinde SDK calls or sync effects.
 */
export const useAuthState = () => {
	const user = useAuthStore((s) => s.user)
	const isAuthenticated = useAuthStore((s) => s.isAuthenticated)
	const isLoading = useAuthStore((s) => s.isLoading)
	const isLoggingOut = useAuthStore((s) => s.isLoggingOut)
	const currentOrganization = useAuthStore((s) => s.currentOrganization)

	return { user, isAuthenticated, isLoading, isLoggingOut, currentOrganization }
}
